const PageLoadingSpinner = () => (
  <div className="flex min-h-[calc(100vh-60px)] flex-col items-center justify-center gap-3 bg-gray-50">
    <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary-500" />
    <span className="text-sm text-gray-400">Chargement...</span>
  </div>
);

export default PageLoadingSpinner;
